/**
 * @flow
 * @author: Vamsi Tallam
 * */

import styled from 'react-emotion'
import Colors from '../../themes/Colors'
import { mobile, customDevice, tablet } from '../../utils/mixins'

export const SectionContainer = styled('section')`
  background-color: ${Colors.blackDefault};
  font-size: 16px;

  ${customDevice(480, 767)} {
    font-size: 16px;
  }
`

export const HeaderSectionContainer = styled('div')`
  min-height: 250px;
  background-image: url('https://res.cloudinary.com/due4dmz2b/image/fetch/dpr_auto,w_auto,f_auto,q_auto/https://proyuga-media-assets.s3.ap-south-1.amazonaws.com/IbcFranchise/franchise-header-bg.png');
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  background-position-y: 95%;
`

export const ResponsiveContainer = styled('div')`
  width: 900px;
  margin: auto;
  display: flex;
  flex-direction: column;
  ${mobile} {
    width: 88.8%;
    margin: auto;
  }
  ${tablet} {
    width: 90%;
    margin: auto;
  }
  ${customDevice(1024, 1140)} {
    width: 90%;
    margin: auto;
  }
`

export const PageContentWrapper = styled(ResponsiveContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 128px;
  padding-bottom: 40px;

  ${mobile} {
    padding-top: 100px;
  }
`

export const PageHeading = styled('p')`
  margin: 0px 0px 10px 0px;
  font-family: Nort;
  font-size: 30px;
  font-weight: bold;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: center;
  color: ${Colors.whiteTwo};
  text-align: center;

  ${mobile} {
    font-size: 24px;
  }
`

export const PageDescription = styled('p')`
  font-family: din-2014;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: center;
  color: ${Colors.whiteThreeTwo};
`



// WEBPACK FOOTER //
// ./src/components/ApplyFranchiseComponent/styledComponents.js